import React from 'react';
import { RandomIllustrationProps } from './types';

export const RandomIllustration: React.FC<RandomIllustrationProps> = (props) => {
  if (props.illustrations) {
    const randomIndex = Math.floor(Math.random() * props.illustrations.length);
    const random = props.illustrations[randomIndex];

    return <div>{random}</div>;
  } else {
    return <></>;
  }
};

export default RandomIllustration;
